import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Button from 'components/base/Button';
import { Alert, Col, Form } from 'react-bootstrap';
import { UseFormRegister, FieldErrors } from 'react-hook-form';

const ForgotPasswordForm = ({
  layout,
  register,
  handleSubmit,
  errors,
  errorMessage,
  message,
  isLoading,
  setErrorMessage
}: {
  layout?: 'simple' | 'card' | 'split';
  register: UseFormRegister<any>;
  handleSubmit: (e: any) => void;
  errors: FieldErrors;
  errorMessage: string | null;
  message: string | null;
  isLoading: boolean;
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
}) => {
  return (
    <div className={classNames({ 'px-xxl-5': !(layout === 'split') })}>
      <div
        className={classNames('text-center', { 'mb-6': !(layout === 'split') })}
      >
        <h4 className="text-1000">Forgot your password?</h4>
        <p className="text-700 mb-5">
          Enter your email below and we will send <br className="d-sm-none" />
          you a reset link
        </p>
        <Form noValidate onSubmit={handleSubmit}>
          <Col md={12} lg={12} sm={12} className="align-items-center mb-5">
            <Form.Control
              type="email"
              {...register('email', {
                required: 'Email is required',
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'Invalid email address'
                }
              })}
              className="w-100"
              placeholder="Email"
              isInvalid={!!errors.email}
            />
            {errors.email && (
              <Form.Control.Feedback type="invalid">
                {errors.email.message as string}
              </Form.Control.Feedback>
            )}
          </Col>
          <Button
            variant="primary"
            className="ms-2"
            endIcon={<FontAwesomeIcon icon={faChevronRight} className="ms-2" />}
            onClick={handleSubmit}
            disabled={isLoading}
          >
            Send
          </Button>
        </Form>
        {message !== '' && <p className="fs-9 fw-bold">{message}</p>}
        {errorMessage !== '' && (
          <Alert
            variant="danger"
            className="text-white"
            onClose={() => setErrorMessage('')}
            dismissible
          >
            <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
            <p>{errorMessage}</p>
          </Alert>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
